module.exports = __webpack_public_path__ + "static/img/fifth3.3e57af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/fifth3.png
// module id = ZkIQ
// module chunks = 25